export default __webpack_public_path__ + "src/_images/DrivingTogether_Wide.png";